module.exports = __webpack_public_path__ + "img/chevron_blue_down.151c932.svg";